import { RSAA } from 'redux-api-middleware'

export const RSAA_EXT = `${RSAA}/ext/redux-foundry`
